module.exports = __webpack_public_path__ + "img/qywechat_oauth2.791fe5a0.png";